import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API_BASE_URL}/auth/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email, password }),
      });
      if (res.ok) {
        const data = await res.json().catch(() => ({}));
        if (data && data.token) {
          localStorage.setItem('adminToken', data.token);
        }
        // Best-effort session verify; don't block navigation if backend lagged in setting cookie
        let ok = false;
        for (let i = 0; i < 5; i++) {
          try {
            await new Promise(r => setTimeout(r, 150 * (i + 1)));
            const authHeaders = data && data.token ? { Authorization: `Bearer ${data.token}` } : {};
            const chk = await fetch(`${API_BASE_URL}/auth/admin/me`, { credentials: 'include', cache: 'no-store', headers: authHeaders });
            if (chk.ok) { ok = true; break; }
          } catch (e) {}
        }
        if (!ok) console.warn('Admin login ok but /auth/admin/me not verified; continuing to /admin');
        navigate('/admin');
      } else {
        const j = await res.json().catch(() => null);
        setError((j && j.error) || 'Giriş başarısız');
      }
    } catch (err) {
      setError('Sunucu ile bağlantı kurulamadı');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900">
      <div className="w-full max-w-md p-8 bg-white dark:bg-[#0f1724] rounded-lg shadow">
        <h2 className="text-2xl font-bold mb-4 text-slate-900 dark:text-white">Yönetici Girişi</h2>
        {error && <div className="mb-3 text-sm text-red-500">{error}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm text-slate-600 dark:text-slate-300 mb-1">E-posta</label>
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="w-full px-3 py-2 rounded bg-slate-100 dark:bg-slate-800" />
          </div>
          <div>
            <label className="block text-sm text-slate-600 dark:text-slate-300 mb-1">Parola</label>
            <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="w-full px-3 py-2 rounded bg-slate-100 dark:bg-slate-800" />
          </div>
          <div className="flex items-center justify-between">
            <button disabled={loading} type="submit" className="px-4 py-2 bg-primary text-white rounded">{loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

